import { createRoute } from '@/utils/routing'

export const DASHBOARD_ROUTE = 'dashboard'

export function createDashboardRoute (options = {}) {
  return createRoute(DASHBOARD_ROUTE, options)
}
